var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("ATTENDING PHYSICIAN")]),_c('h4',[_vm._v(" An Affiliated Physician who is part of the medical staff of an Affiliated Hospital or Affiliated Medical Clinic, and legally responsible for the care given to a Member while in the hospital or on out-patient basis. ")])])
}]

export { render, staticRenderFns }